import { ADD_RECIPE, SET_LOADING, RECIPE_ERROR, GET_RECIPES } from ".";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";

export const addRecipe = (recipe) => (dispatch) => {
	axiosWithAuth()
		.post("/api/recipes", recipe)
		.then((res) => {
			dispatch({ type: ADD_RECIPE, payload: res.data });
		})
		.catch((err) => {
			console.log("error adding", err);
			dispatch({ type: RECIPE_ERROR, payload: err.response.data });
		});
};

export const getRecipes = () => async (dispatch) => {
	axiosWithAuth()
		.get("/api/recipes")
		.then((res) => {
			dispatch({ type: GET_RECIPES, payload: res.data });
		})
		.catch((err) => {
			dispatch({ type: RECIPE_ERROR, payload: err.response.data });
		});
};

export const setLoading = () => {
	return { type: SET_LOADING };
};
